import React from 'react';
import PropTypes from 'prop-types';

import FormManager from 'src/core/gd-form/common/form-manager';
import TimeAllocation from "src/core/gd-ui/time-allocation/time-allocation";
import AutoDistributionOptions from "core/gd-ui/time-allocation/auto-distribution-options/auto-distribution-options";
import WorkdayDistributionOptions from "core/gd-ui/time-allocation/workday-distribution-options/workday-distribution-options";
import ButtonSubmit from "../../../gd-form/common/btn-submit/btn-submit";

class ModalActionTimeAllocation extends React.Component {
    static propTypes = {
        onSubmit: PropTypes.func.isRequired
    }

    UNSAFE_componentWillMount() {
        const company = gd.session.companies.get(gd.companyId)
        const initFormData = {
            mode: company.settings.modules.workload.allocationMode,
            type: company.settings.modules.workload.allocationType,
        };

        const formStructure = {
            fields: {
                mode: { type: 'select', isRequired: false },
                type: { type: 'select', isRequired: false }
            },
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure,initFormData);
    }

    onSubmit = (result) => {
        this.props.onSubmit(result);
    }

    onModeSelected = (value) => {
        this.form.onFormComponentValueChange('mode', value);
        switch (value) {
            case gd.const.timeline.timeAllocation.distributionMode.AUTO:
                this.form.onFormComponentValueChange('type', gd.const.timeline.timeAllocation.autoDistributionType.FRONT_LOAD);
                break;

            case gd.const.timeline.timeAllocation.distributionMode.WORKDAY_BASED:
                this.form.onFormComponentValueChange('type', 100);
                break;
        }
        this.forceUpdate();
    }

    onTypeSelected = (value) => {
        this.form.onFormComponentValueChange('type', value);
        this.forceUpdate();
    }

    render() {
        const allocationMode = this.form.getValue('mode');
        const allocationType = this.form.getValue('type');

        let typeLabel = '';
        switch (allocationMode) {
            case gd.const.timeline.timeAllocation.distributionMode.AUTO:            typeLabel = 'Distribution'; break;
            case gd.const.timeline.timeAllocation.distributionMode.WORKDAY_BASED:   typeLabel = 'Workday'; break;
        }

        return (
            <div className="gd-form-modal-new">
                <div className="tbl">
                    <div className="row">
                        <div className="label">Time allocation</div>
                        <div className="element">
                            <div className="content-row m-t-5">
                                <TimeAllocation allocationMode={allocationMode} onSelect={this.onModeSelected}/>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="label" style={{verticalAlign: 'top', paddingTop: 10}}>{typeLabel}</div>
                        <div className="element" style={{verticalAlign: 'top', height: 76}}>
                            {[gd.const.timeline.timeAllocation.distributionMode.AUTO].includes(allocationMode) &&
                            <div className="content-row m-t-5">
                                <AutoDistributionOptions value={allocationType} onSelect={this.onTypeSelected}/>
                            </div>}

                            {[gd.const.timeline.timeAllocation.distributionMode.WORKDAY_BASED].includes(allocationMode) &&
                            <WorkdayDistributionOptions inputRowClassName="content-row m-t-5" value={allocationType} onSelect={this.onTypeSelected}/>}
                        </div>
                    </div>
                </div>
                <div className="actions">
                    <ButtonSubmit form={this.form} label="Submit" className="submit"/>
                </div>
            </div>
        )

        /*return (
            <div className="ui5-plate white-on-gray">
                <div className="ui5-form size-30-70">
                    <div className="f-tbl min-h-100">
                        <div className="f-row">
                            <div className="f-label">Time allocation</div>
                            <div className="f-element">
                                <div className="f-content-row m-t-5">
                                    <TimeAllocation allocationMode={allocationMode} onSelect={this.onModeSelected}/>
                                </div>
                            </div>
                        </div>

                        <div className="f-row">
                            <div className="f-label">{typeLabel}</div>
                            <div className="f-element">
                                {[gd.const.timeline.timeAllocation.distributionMode.AUTO].includes(allocationMode) &&
                                <div className="f-content-row m-t-5">
                                    <AutoDistributionOptions value={allocationType} onSelect={this.onTypeSelected}/>
                                </div>}

                                {[gd.const.timeline.timeAllocation.distributionMode.WORKDAY_BASED].includes(allocationMode) &&
                                <WorkdayDistributionOptions inputRowClassName="f-content-row m-t-5" value={allocationType} onSelect={this.onTypeSelected}/>}
                            </div>
                        </div>
                    </div>
                    <div className="actions">
                        <ButtonSubmit form={this.form} label="Submit" className="submit" />
                    </div>
                </div>
            </div>
        );*/
    }
}

module.exports = ModalActionTimeAllocation;